import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Characters from './components/Characters';
import Relations from './components/Relations';
import Gallery from './components/Gallery';
import CtaBanner from './components/CtaBanner';
import Faq from './components/Faq';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingActions from './components/FloatingActions';
import { faqs } from '@/mocks/galData';

const schema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '泡在我家的辣妹角色介绍',
      url: 'https://lameshi.github.io/',
      description:
        '泡在我家的辣妹角色介绍一站看全：女主是谁、男主设定、人物关系图与角色图都有，帮助你快速入坑。',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'WebPage',
      name: '泡在我家的辣妹角色介绍',
      url: 'https://lameshi.github.io/',
      inLanguage: 'zh-CN',
      description:
        '泡在我家的辣妹角色介绍：女主是谁、男主设定、人物关系图与角色图大全。想搞清泡在我家的辣妹人物关系，一看即懂。',
    },
    {
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.q,
        acceptedAnswer: { '@type': 'Answer', text: faq.a },
      })),
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://lameshi.github.io/',
        },
      ],
    },
  ],
};

export default function Home() {
  useEffect(() => {
    const existing = document.getElementById('gal-schema');
    if (!existing) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'gal-schema';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }, []);

  return (
    <main id="main">
      <Navbar />
      <Hero />
      <Characters />
      <Relations />
      <Gallery />
      <CtaBanner />
      <Faq />
      <About />
      <Contact />
      <Footer />
      <FloatingActions />
    </main>
  );
}